import { createContext, useState, useCallback } from "react";

export const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger(prev => !prev);
  }, []);

  return (
    <WebSocketContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </WebSocketContext.Provider>
  );
};